import {AxiosRequestConfig} from "axios";
import environment from '../../config/env'
import {AuthorizedService} from "../../service/authorized.service";
import {MsEntraAuthState} from "./auth-types";
import {User} from "./user-model";

class AuthService extends AuthorizedService {
    private accessToken?: string | null;
    private idToken?: string | null;
    private nonce?: string | null;
    private config?: AxiosRequestConfig | null;
    private user?: User | null;

    get requestConfig(): AxiosRequestConfig | undefined | null {
        return this.config;
    }

    set msalAuthSate(authState: MsEntraAuthState | null) {
        if (authState?.accessToken) {
            this.accessToken = authState.accessToken;
            this.idToken = authState.idToken;
            this.nonce = authState.nonce;
            this.config = {
                headers: {
                    Authorization: 'Bearer ' + this.accessToken,
                    'id_token': this.idToken as string,
                    'nonce': this.nonce as string
                },
            };
            this.storeTokens(authState);
        } else {
            this.accessToken = null;
            this.idToken = null;
            this.nonce = null;
            this.config = {};
            this.clearSession();
            this.clearTokens();
        }
    }

    public getLoggedUser(): User | undefined | null {
        if (this.user) {
             return this.user;
        }
        const user = this.getStoredSession();
        if (user) {
            this.user = user;
            this.restoreTokens();
        }
        return user;
    }

    public setLoggedUser(user: User | null): void {
        this.user = user;
        if (user) {
            this.storeSession(user);
        } else {
            this.clearSession();
            this.clearTokens();
        }
    }

    public storeUser(id?: string, email?: string, fullName?: string): Promise<void> {
        return super.post('user/storeUser', null, {params: {id, email, fullName}});
    }

    private getStoredSession(): User | undefined | null {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    }

    private storeSession(user?: User | null): void {
        localStorage.setItem('user', JSON.stringify(user));
    }

    private clearSession(): void {
        localStorage.removeItem('user');
    }

    // Methods to handle tokens
    private storeTokens(authState: MsEntraAuthState): void {
        localStorage.setItem('authTokens', JSON.stringify({
            accessToken: authState.accessToken,
            idToken: authState.idToken,
            nonce: authState.nonce
        }));
    }

    private restoreTokens(): void {
        const tokensData = localStorage.getItem('authTokens');
        if (tokensData) {
            const tokens = JSON.parse(tokensData);
            this.accessToken = tokens.accessToken;
            this.idToken = tokens.idToken;
            this.nonce = tokens.nonce;
            this.config = {
                headers: {
                    Authorization: 'Bearer ' + this.accessToken,
                    'id_token': this.idToken as string,
                    'nonce': this.nonce as string
                },
            };
        }
    }

    private clearTokens(): void {
        localStorage.removeItem('authTokens');
    }
}

export default new AuthService(environment.ADMIN_API_URL)